import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { User } from '../../models/user/user-model';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class UserService {
  private serviceName = 'api/user';
  constructor(private http: Http, public toastr: ToastsManager, private cookieService: CookieService) {
  }

  getUsers() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addUser(userModel: User) {

    return this.http
      .post(`${this.serviceName}/InsertUser`, userModel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  ForgotPassword(email: string) {
   
    return this.http.get(`${this.serviceName}/ForgotPasswordAsync?email=` + email, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  ResetPassword(email: string, password: string, token: string) { 
    return this.http.get(`${this.serviceName}/ResetPassword?email=` + email + `&password=` + password + `&token=` + token, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  updateUser(userModel: User) {
    return this.http.post(`${this.serviceName}/UpdateUser`, userModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  UpdateUserFullName() {
    return this.http.get(`${this.serviceName}/UpdateUserFullName`,{
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  deleteUser(id: string) {
    return this.http.get(`${this.serviceName}/DeleteUser?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getUser(userId: string) {
    return this.http.get(`${this.serviceName}/GetUserById?id=` + userId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  isUniqueEmail(email: string) {
    return this.http
      .get(`${this.serviceName}/IsUniqueEmail?email=` + email, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user/user.service.ts